var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsStepUpArraowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6401 11.9238H0V12.8294H14.6401V11.9238Z",
    fill: "#2BB380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6261 0V0.905571H13.0943L8.30124 5.69867L6.33917 3.7366L0.132812 9.94293L0.773111 10.5832L6.33917 5.01725L8.30124 6.97935L13.7347 1.5459V3.01413H14.6402V0H11.6261Z",
    fill: "#2BB380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsStepUpArraowGreen);
export default __webpack_public_path__ + "static/media/analyticsStepUpArraowGreen.2bee9795ee353cfff9e20458737234ae.svg";
export { ForwardRef as ReactComponent };